import { OKTA_LOGO } from 'constants/icons';
import useCountdown from 'hooks/useCountdown';
import Image from 'next/image';
import { defaultFnType } from 'types';

interface LoginRedirectMessage {
  onComplete: defaultFnType;
  startDuration: number;
}

const LoginRedirectMessage: React.FC<LoginRedirectMessage> = ({ onComplete }) => {
  const { remainingTime } = useCountdown(onComplete, 3);

  return (
    <div className='f-14-400 tw-mt-2 tw-flex tw-items-center tw-gap-1'>
      Redirecting to
      <Image
        src={OKTA_LOGO}
        width={80}
        height={30}
        alt='Login with Okta'
        onClick={onComplete}
        className='tw-shadow-md tw-px-4 tw-py-2 tw-pt-2.5 tw-rounded-2.5 hover:tw-bg-BASE_PRIMARY tw-cursor-pointer tw-border'
      />
      in {remainingTime >= 0 ? remainingTime : 0} seconds.
    </div>
  );
};

export default LoginRedirectMessage;
